import React from 'react';
import styled from 'styled-components';
import { colors, neumorphism } from '../constant';
import { respondTo } from '../responsive';

const CollapseButton = ({ isOpen, onClick }) => {
    return (
        <Button type="button" onClick={onClick} >
            <svg width="1em" height="1em" viewBox="-2 -5 18 14">
                <Path isOpen={isOpen}
                    d="M6.09173 8.6208L0.301065 2.00186C-0.382321 1.22309 0.173081 4.43966e-07 1.21023 4.43966e-07H12.7916C13.0237 -0.000198568 13.2509 0.0665128 13.4461 0.192146C13.6413 0.317779 13.7961 0.497009 13.892 0.70837C13.988 0.919732 14.021 1.15427 13.987 1.38389C13.9531 1.61351 13.8537 1.82849 13.7007 2.00307L7.91007 8.61959C7.79674 8.74928 7.65698 8.85322 7.50017 8.92444C7.34336 8.99565 7.17313 9.0325 7.0009 9.0325C6.82868 9.0325 6.65844 8.99565 6.50163 8.92444C6.34482 8.85322 6.20506 8.74928 6.09173 8.61959V8.6208Z" 
                    fill="currentColor"/>
            </svg>
        </Button>
    )
}

const Button = styled.button`
    background-color: #F4F4F4;
    border-radius: 50em;
    border: none;
    outline: none;

    width: 32px;
    height: 32px;

    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    bottom: 16px;
    right: 16px;

    z-index: 10;

    color: ${ colors.text };
    font-size: 14px;

    ${ neumorphism.convex };
    transition: all .2s;

    &:active {
        ${ neumorphism.concave };
    }

    ${ respondTo.md } {
        bottom: 8px;
        right: 8px;
        padding: 0;
    }
`

const Path = styled.path`
    transition: transform .3s;
    transform-origin: 50% 30%;
    transform: rotateX(${({isOpen}) => isOpen ? '180deg' : '0deg' });
`

export default CollapseButton;
